import { Link } from "react-router-dom";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_f90d4e05-9645-467f-ac1d-dd751e6fd365/artifacts/bggrzoq8_FullLogo_Transparent_NoBuffer.png";

/**
 * Logo — single full logo (icon + wordmark).
 *   size: sm | md | lg | xl
 *   variant: "default" (dark on light) | "invert" (for dark bg)
 */
export function Logo({
  className = "",
  size = "md",
  variant = "default",
  linkTo = "/",
  noLink = false,
}) {
  const sizes = {
    sm: "h-10",
    md: "h-14",
    lg: "h-20",
    xl: "h-28",
  };

  const invertCls = variant === "invert" ? "brightness-0 invert" : "";

  const img = (
    <img
      src={LOGO_URL}
      alt="Albany Staffing"
      className={`${sizes[size]} w-auto object-contain ${invertCls} ${className}`}
    />
  );

  if (noLink) return img;

  return (
    <Link to={linkTo} aria-label="Albany Staffing — Home" className="inline-flex items-center shrink-0">
      {img}
    </Link>
  );
}
